const ragStatusColors = {
  red: '#e84c3d',
  amber: '#f39c11',
  green: '#18bb9c',
};

const maxCredentialsLength = 20;

const numOfDaysInA = {
  week: 7,
  month: 28,
};

const numberOf = {
  daysInAMonth: 28,
  weeksInAYear: 52,
  monthsInAYear: 12,
};

const auditActionType = {
  0: 'Read',
  1: 'Patient added',
  2: 'Patient edited',
  3: 'Patient removed',
};

const logTypeEnums = [
  { name: 'Any', id: -1 },
  { name: 'In Progress', id: 0 },
  { name: 'Successful Allocation', id: 1 },
  { name: 'Unsuccessful Allocation', id: 2 },
  { name: 'Auto Restarted', id: 3 },
];

const epRequestEnums = [
  { name: 'All', id: 0, value: 'All' },
  { name: 'Not Sent', id: 1, value: 'NotSent' },
  { name: 'Sent', id: 2, value: 'Sent' },
  { name: 'Failed', id: 3, value: 'Failed' },
  { name: 'Discarded', id: 4, value: 'Discarded' },
  { name: 'Cancelled', id: 5, value: 'Cancelled' },
];

export { ragStatusColors, maxCredentialsLength, numOfDaysInA, numberOf, auditActionType, logTypeEnums, epRequestEnums };
